import { type PolicyCookies } from '~~/package/utils/CookieUtil';

// GDPR에 따라 쿠키 동의 팝업이 필요한 국가/지역 (기획 참조 파일 24.09.24 기준과 일치 확인, 2026-07-10).
// EU 27개국 + GB, IS, LI, NO, CH(유사법). app.vue에서 이곳으로 이동.
export const gdprCountries = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE',
    'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT',
    'RO', 'SK', 'SI', 'ES', 'SE', 'GB', 'IS', 'LI', 'NO', 'CH'
];

export type ConsentAction = 'popup' | 'auto-accept' | 'none';

// 판정 불가(xCountry === '')는 GDPR로 간주해 popup을 반환한다 (A안, 2026-07-10 확정).
// functional === undefined는 개정 전 쿠키 → 재동의 대상.
export const resolveConsentAction = (policy: PolicyCookies, xCountry: string): ConsentAction => {
    const needsConsent = !policy.necessary || policy.functional === undefined;
    if (!needsConsent) return 'none';

    const isKnownNonGdpr = !!xCountry && !gdprCountries.includes(xCountry);
    return isKnownNonGdpr ? 'auto-accept' : 'popup';
};

// 비GDPR 자동 허용 값. 기존 동의자의 performance 선택은 덮어쓰지 않는다.
export const buildAutoAcceptPolicy = (policy: PolicyCookies): PolicyCookies => ({
    necessary: true,
    performance: policy.necessary ? policy.performance : true,
    functional: true,
});

// x-country 헤더가 있는 응답에서만 값을 채운다. 헤더 없는 응답이 store를
// undefined로 오염시키면 재시도 경로(afterEach의 setXCountry)가 끊긴다.
export const nextXCountry = (current: string, headerValue?: string): string =>
    !current && headerValue ? headerValue : current;

export const canBootChannelTalk = (uuid: string | undefined, functional: boolean | undefined): boolean =>
    !!uuid && functional === true;

// 국가 조회 성공/실패와 무관하게 후속 판정을 실행한다. 조회가 실패해도
// xCountry='' (판정 불가)로 남아 resolveConsentAction이 팝업(A안)으로 처리하게 하는 계약.
export const afterCountryLookup = (lookup: Promise<unknown>, next: () => void): Promise<void> =>
    lookup.then(() => next(), () => next());
